import { Errors} from '@startlibs/form'
import React, { useEffect, useRef } from 'react'
import { smoothScroll } from '@startlibs/utils'
import { IntakeFormCard } from './PatientDetailsNew';
import { SplitColumnsContainer } from '@startlibs/components';
import { CustomInput } from '../../components/customFormsFields/CustomInput';

export const CustomFields = ({ id, title, description, NavigationButtons, lines, fromAdminEditPage = false, readOnly = false, isMultiLanguage,  defaultLanguage, intl, translations, scrollTo }) => {

  const headerRef = useRef()

  useEffect(() => {
    if(scrollTo){
      smoothScroll({ target: headerRef.current, offset: -200 })
    }
  }, [title])

  const tabTitle = isMultiLanguage && title
    ? (() => {
        const translation = translations?.find(t => t.language === intl.locale);
        return translation?.name === "" ? "" : translation?.name || title;
      })()
    : title;
  
  const tabDescription = isMultiLanguage && description
    ? (() => {
        const translation = translations?.find(t => t.language === intl.locale);
        return translation?.description === "" ? "" : translation?.description || description;
      })()
    : description;
    
  return <>
    <IntakeFormCard fromAdminEditPage={fromAdminEditPage}>
      <div>
        <h3 ref={headerRef}>{tabTitle}</h3>
        <p>{tabDescription}</p>

        {lines.map((line, _index) => {
          // Check if has both left and right fields
          if (line.left && line.right) {
            return <SplitColumnsContainer viewportMinWidth={500} margin="big" style={{alignItems: 'center'}}>
              <CustomInput input={line.left}  tabId={id} readOnly={readOnly} isMultiLanguage={isMultiLanguage} defaultLanguage={defaultLanguage} intl={intl} />
              <CustomInput input={line.right} tabId={id} readOnly={readOnly} isMultiLanguage={isMultiLanguage} defaultLanguage={defaultLanguage} intl={intl} />
            </SplitColumnsContainer>
          }

          // Check if has only left field
          if (line.left) {
            return <CustomInput input={line.left} tabId={id} readOnly={readOnly} isMultiLanguage={isMultiLanguage} defaultLanguage={defaultLanguage} intl={intl} />
          }
        })}
      </div>
      <Errors path={`${id}`} />
      <NavigationButtons />
    </IntakeFormCard>
  </>
}
